import { createLucideIcon } from "lucide-react";

export const ArrowUpDown = createLucideIcon(
    "ArrowUpDown",
    [
        [
            "path",
            {
                d: "M14 17.0001L16.2929 19.463C16.6262 19.8211 16.7929 20.0001 17 20.0001C17.2071 20.0001 17.3738 19.8211 17.7071 19.463L20 17.0001",
                key: "1d3pos",
            },
        ],
        [
            "path",
            {
                d: "M17 18.9999L17 3.99994",
                key: "9bt2k5",
            },
        ],
        [
            "path",
            {
                d: "M4 7.00006L6.29289 4.53714C6.62623 4.17909 6.79289 4.00006 7 4.00006C7.20711 4.00006 7.37377 4.17909 7.70711 4.53714L10 7.00006",
                key: "gn3ekc",
            },
        ],
        [
            "path",
            {
                d: "M7 5.00006V20.0001",
                key: "161kwh",
            },
        ],
    ],
);
